import { getIn } from "formik";
import { FormikDisplaySettingsFields } from "../../../../../api/graphql/rooms/rooms";

export const themeFieldsChanged = (
  values: FormikDisplaySettingsFields,
  initialValues: FormikDisplaySettingsFields
) =>
  [
    "main.layoutTheme.useColorImage",
    "main.layoutTheme.backgroundImageOpacity",
    "main.layoutTheme.themeVersion",
    "main.layoutTheme.customHexColors.busy",
    "main.layoutTheme.customHexColors.free",
    "main.layoutTheme.customHexColors.tentative",
  ].some((path) => {
    const current = getIn(values, path);
    const initial = getIn(initialValues, path);
    return current !== initial;
  });
